import { render } from "./FacultyWorkload.vue?vue&type=template&id=7a281c4d"
import script from "./FacultyWorkload.vue?vue&type=script&lang=js"
export * from "./FacultyWorkload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__